// extracted by mini-css-extract-plugin
export default {"container":"BreadCrumb_container__Q5Xqs","button":"BreadCrumb_button__MOp8R","separator":"BreadCrumb_separator__BqRe0"};